"use client";

import { useEffect } from "react";

export default function HubspotForm() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://js.hsforms.net/forms/embed/v2.js";
    script.type = "text/javascript";
    script.async = true;

    script.onload = () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: "43968755",
          formId: "e244fce4-c597-42ff-a752-8488b2d0fe05",
          region: "na1",
          target: "#hubspotForm",
        });
      }
    };

    document.body.appendChild(script);
  }, []);

  return <div data-component-id="src/app/contact/HubspotForm.tsx:26:9" data-component-path="src/app/contact/HubspotForm.tsx" data-component-line="26" data-component-end-line="26" data-component-file="HubspotForm.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22id%22%3A%22hubspotForm%22%2C%22className%22%3A%22w-full%20md%3Aw-1%2F2%22%7D" id="hubspotForm" className="w-full md:w-1/2" />;
}
